export const ROOM_NAME = "odds_are";

export const MIN_PLAYERS = 3;
export const MAX_PLAYERS = 8;

/** Phase lengths in milliseconds. The server owns every timer. */
export const PHASE_DURATION_MS = {
  lobby: 0,
  prompt: 20_000,
  voting: 15_000,
  reveal: 8_000,
  scoreboard: 12_000,
} as const;

export const ROUNDS_PER_SESSION = 20;

/** Points awarded to each player who received the most votes in a round. */
export const POINTS_PER_ROUND_WIN = 1;

/** Upper bound on messages per second before Colyseus drops the client. */
export const MAX_MESSAGES_PER_SECOND = 10;
